exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh3[data-v-512b85b0] {\n  margin-top: 20px;\n}\n.nuv[data-v-512b85b0] {\n  font-size: 16px;\n}\n.current[data-v-512b85b0] {\n  border: 1px solid #dfdfdf;\n  background-color: #ffffff;\n}\n.current .tab[data-v-512b85b0] {\n  border-bottom: 1px solid #dfdfdf;\n  padding: 10px;\n  font-size: 16px;\n  font-weight: bold;\n}\n.current .content[data-v-512b85b0] {\n  padding: 10px;\n}\ntable > tr > th[data-v-512b85b0], table > tr > td[data-v-512b85b0] {\n  padding: 5px;\n}\n.content .button[data-v-512b85b0] {\n  margin: 0px 5px 10px 5px;\n}\n.end[data-v-512b85b0] {\n  margin-bottom: 20px;\n  margin-top: 10px;\n}\n.end > span[data-v-512b85b0] {\n  padding: 0 20px;\n  font-size: 18px;\n}\n.nopeople[data-v-512b85b0] {\n  padding: 10px 0 20px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-512b85b0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/page/provider/enterExam.vue
// module id = 1201
// module chunks = 0